import { render } from "./PrefixReferencedOrcids.vue?vue&type=template&id=5ca93f96&scoped=true"
import script from "./PrefixReferencedOrcids.vue?vue&type=script&lang=js"
export * from "./PrefixReferencedOrcids.vue?vue&type=script&lang=js"

import "./PrefixReferencedOrcids.vue?vue&type=style&index=0&id=5ca93f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca93f96"]])

export default __exports__